import * as React from "react";
import {formatPrice, isEmpty, mapObjectName, mapObjectToArray, sectionsToSubsections} from "../lib/tools";
import {Button, Image, SearchField, SortedTable} from "../components/common/common";
import {getImage} from "../lib/api";
import {DropDown} from "../components/common/formValidation";
import {reduxWrapper} from "../globalState";


class SectionOverrideToolRender extends React.Component {
	
	state = {
		products: [],
		vendors: [],
		order: "id",
		orderAsc: true,
		page: 0,
		loading: false,
		overrideSection: {},
		overrideType: {}
	};
	
	componentWillMount() {
		const savedData = localStorage.getItem("productAdminFilter");
		if (savedData)
			this.setState(JSON.parse(savedData));
		else
			this.props.awaitVendors(data => this.setState({vendors: mapObjectToArray(data, x => x.id)}));
		
		this.loadProducts();
		
		this.props.awaitSections(sections => this.subsections = sectionsToSubsections(sections, true));
	}
	
	componentWillUnmount() {
		localStorage.setItem("productAdminFilter", JSON.stringify(this.state));
	}
	
	timeout = null;
	search = "";
	subsections = {};
	
	onSearch(val) {
		this.search = val;
		this.setState({page: 0});
		this.loadProducts();
	}
	
	changeVendors(val) {
		this.setState({vendors: val, page: 0});
		this.loadProducts();
	}
	
	loadProducts() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({loading: true});
			this.props.apiCall("GET", "admin/products", products => this.setState({products, loading: false, overrides: {}}), {
				search: this.search,
				simple: true,
				limit: 20,
				limitOffset: this.state.page * 20,
				orderBy: this.state.order,
				orderAsc: this.state.orderAsc,
				vendors: this.state.vendors,
				all: true,
				imported: true
			})
		}, 1000);
	}
	
	tableChange(data) {
		this.setState(data);
		this.loadProducts();
	}
	
	setOverrideSection(id, val) {
		this.props.apiCall("PUT", `admin/override/product/${id}/section`, null, {section: val})
			.then(() => this.setState(p => ({overrideSection: {...p.overrideSection, [id]: val || ""}})))
	}
	
	setOverrideType(id, val) {
		this.props.apiCall("PUT", `admin/override/product/${id}/type`, null, {type: val})
			.then(() => this.setState(p => ({overrideType: {...p.overrideType, [id]: val || ""}})))
	}
	
	columns = {
		id: {
			name: "ID",
			sortable: true
		},
		thumbnail: {
			name: "Image",
			render: val => <Image src={getImage(val)}/>
		},
		name: {
			name: "Name",
			sortable: true
		},
		price: {
			name: "Price",
			sortable: true,
			render: val => formatPrice(val)
		},
		vendor: {
			name: "Vendor",
			sortable: true,
			render: val => val ? this.props.vendors[val].name : "N/A"
		},
		isRentable: {
			name: "Rentable",
			render: val => val ? "Yes" : "No"
		},
		disabled: {
			name: "Status",
			sortable: true,
			render: val => !val ? "Enabled" : "Disabled"
		},
		productType: {
			name: "Type",
			sortable: true,
			render: (val, row) => <DropDown options={this.props.productTypes} value={val} onChange={v => this.setOverrideType(row.id, v)}/>
		},
		overrideSection: {
			name: "Section",
			sortable: true,
			render: (val, row) => <DropDown options={this.subsections} value={val} onChange={v => this.setOverrideSection(row.id, v)}/>
		}
	};
	
	render() {
		const {productTypes, vendors} = this.props;
		return (
			<div className="wrapper">
				<div className="header">
					<SearchField onSubmit={val => this.onSearch(val)}/>
					<DropDown options={mapObjectName(vendors)} multiple value={this.state.vendors} onChange={val => this.changeVendors(val)} title="Vendors"/>
				</div>
				<SortedTable
					columns={this.columns}
					onChange={val => this.tableChange(val)}
					loading={isEmpty(vendors) || this.state.loading || isEmpty(productTypes)}
					values={this.state}
					rows={(this.state.products || []).map(x => ({...x, productType: this.state.overrideType[x.id] || x.productType, overrideSection: this.state.overrideSection[x.id] || x.overrideSection}))}/>
			</div>
		);
	}
}

const SectionOverrideTool = reduxWrapper("getApiCall", "loadProductTypes", "loadVendors", "loadSections")(SectionOverrideToolRender);


export default SectionOverrideTool;


// WEBPACK FOOTER //
// ./src/admin/SectionOverrideTool.js